import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MeterEventsComponent } from '../meter-events/meter-events.component';

@Component({
  selector: 'app-meter-events-dialog',
  imports: [MatButtonModule, MatDialogModule, MeterEventsComponent],
  templateUrl: './meter-events-dialog.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeterEventsDialogComponent {
  readonly userUid = input.required<string>();

}
